import axios from 'axios';

export const publicRequest = axios.create({
    baseURL: 'https://cvmaker.nimapinfotech.com/api'
})